import React, { useState, useEffect } from 'react';
import {} from 'reactstrap';
import { toast } from 'react-toastify';
import Api from '../../util/api';
import Loading from '../../shared/components/custom/Loading';
import t, { partial } from '../../util/translation/translation';
import moment from 'moment';
import GoalSponsorContactForm from './components/GoalSponsorContactForm';
import PlanEmailHistory from './components/PlanEmailHistory';
import OfferTypes from '../offers/types';

const GoalSponsorContactFormPage = ({ subscriptionPlan }) => {
  const [scheduleMessageID, setScheduleMessageID] = useState(null);
  const [scheduleMessagesForEvent, setScheduleMessagesForEvent] = useState([]);
  const [messageStatus, setMessageStatus] = useState('Scheduled');
  const [totalAmountOfScheduledMessages, setTotalAmountOfScheduledMessages] =
    useState(0);
  const [startDate, setStartDate] = useState();
  const [emails, setEmails] = useState([]);
  const [emailRecipientCount, setEmailRecipientCount] = useState(null);
  const p = partial('goalSponsor');
  const s = partial('shared');
  const o = partial('OffersFormPage');

  // Emails go to every supporter of the plan (guests included); push is unchanged below
  const loadEmails = async () => {
    if (!subscriptionPlan?.id) return;
    try {
      const res = await Api.goalSponsor.communication.listEmails(
        subscriptionPlan.id
      );
      setEmails(res.data?.messages || []);
      setEmailRecipientCount(res.data?.recipientCount ?? null);
    } catch (_e) {
      setEmails([]);
    }
  };

  useEffect(() => {
    loadEmails();
  }, [subscriptionPlan?.id]);

  const sendEmail = async (values) => {
    const scheduledDate =
      values.timeToSend === 'SCHEDULED' ? moment.utc(startDate).format() : null;
    try {
      await Api.goalSponsor.communication.sendEmail(subscriptionPlan.id, {
        title: values.title,
        message: values.message,
        navigationType: values.navigationType?.value || 'plan',
        ...(scheduledDate ? { scheduledDate } : {}),
      });
      toast.success(
        scheduledDate
          ? `${t('ScheduledMessagesPage.messageScheduled')}`
          : o('emailSent')
      );
    } catch (_e) {
      toast.error(s('somethingWentWrong'));
    }
    loadEmails();
  };

  const cancelEmail = async (messageId) => {
    try {
      await Api.goalSponsor.communication.cancelEmail(
        subscriptionPlan.id,
        messageId
      );
    } catch (_e) {
      toast.error(s('somethingWentWrong'));
    }
    loadEmails();
  };

  const handleContact = async (values) => {
    if (values.type === OfferTypes.CommunicationTypes.email) {
      await sendEmail(values);
      return;
    }
    const { title, message, type, timeToSend, notificationLabel } = values;
    const scheduledDate =
      timeToSend === 'SCHEDULED' ? moment.utc(startDate).format() : null;
    const payload = {
      navigationType: values.navigationType.value,
      title,
      message,
      receiverType: values.receiverType.value,
      notificationLabel: notificationLabel?.value || null,
    };

    try {
      if (timeToSend === 'SCHEDULED' && scheduleMessageID) {
        await Api.goalSponsor.communication.updateScheduledMessage(
          subscriptionPlan.id,
          scheduleMessageID,
          { ...payload, scheduledDate }
        );
        toast.success(`${t('ScheduledMessagesPage.scheduleMessageUpdated')}`);
      } else if (timeToSend === 'INSTANT') {
        await Api.goalSponsor.communication.contactGoalSponsor(
          subscriptionPlan.id,
          payload
        );
      } else {
        await Api.goalSponsor.communication.contactGoalSponsor(
          subscriptionPlan.id,
          {
            ...payload,
            scheduledDate,
          }
        );
        toast.success(`${t('ScheduledMessagesPage.messageScheduled')}`);
      }
      if (timeToSend === 'INSTANT') {
        if (type === OfferTypes.CommunicationTypes.push) {
          toast.success(o(`${'pushNotificationSent'}`));
        } else if (type === OfferTypes.CommunicationTypes.email) {
          toast.success(o(`${'emailSent'}`));
        } else {
          toast.success(o(`${'smsSent'}`));
        }
      }
    } catch (_e) {
      toast.error(s(`${'somethingWentWrong'}`));
    }
    getScheduleMessagesByServiceId();
    setScheduleMessageID(null);
  };
  const getScheduleMessagesByServiceId = async (page = 1, pageSize = 10) => {
    try {
      let messageByEventId = [];

      if (messageStatus === t('ScheduledMessagesPage.filterByStatus')) {
        messageByEventId =
          await Api.scheduleMessages.getScheduleMessagesByServiceId(
            subscriptionPlan.id,
            page,
            pageSize
          );
      } else {
        messageByEventId =
          await Api.scheduleMessages.getScheduleMessagesByServiceIdByStatus(
            subscriptionPlan.id,
            page,
            pageSize,
            messageStatus
          );
      }
      setScheduleMessagesForEvent(messageByEventId.data.data);
      setTotalAmountOfScheduledMessages(messageByEventId.data.total);
    } catch (error) {
      console.log(error);
      toast.error(error);
    }
  };

  return (
    <>
      <GoalSponsorContactForm
        emailRecipientCount={emailRecipientCount}
        onSubmit={handleContact}
        subscriptionPlan={subscriptionPlan}
        scheduleMessageID={scheduleMessageID}
        setScheduleMessageID={setScheduleMessageID}
        scheduleMessagesForEvent={scheduleMessagesForEvent}
        getScheduleMessagesByServiceId={getScheduleMessagesByServiceId}
        setScheduleMessagesForEvent={setScheduleMessagesForEvent}
        totalAmountOfScheduledMessages={totalAmountOfScheduledMessages}
        messageStatus={messageStatus}
        setMessageStatus={setMessageStatus}
        startDate={startDate}
        setStartDate={setStartDate}
      />
      <PlanEmailHistory messages={emails} onCancel={cancelEmail} />
    </>
  );
};

export default GoalSponsorContactFormPage;
